<flx-modal
  [dismissible]="true"
  (dismiss)="closeModal()"
  class="flx-ds medium"
  data-testId="confirmation-dialog"
>
  <div
    class="flx-modal-title font-normal"
    flxModalHeaderTitle
  >
    Are you sure you want to {{ data.action === 'update' ? 'update' : 'delete' }}
    @if (data.attribute) {
      <span class="font-bold">{{ data.attribute.name }}</span> attribute in
    }
    <span class="font-bold">{{ data.dataType?.name }}</span>
    type?
  </div>

  @if (data.resourceUsages.length > 0) {
    <div
      class="flx-modal-subtitle"
      flxModalHeaderSubtitle
    >
      This {{ ApplicationResourceType.ProjectDataType }} is used in several resources.
      {{ data.action === 'update' ? 'Updating' : 'Deleting' }} it may break references and impact
      configurations.
    </div>
  }

  <div class="flx-modal-body">
    <flx-resource-usages-delete-confirmation
      [resourceUsages]="data.resourceUsages"
      (viewUsagesClicked)="openResourceUsagesModal(data.dataType, 'fromDeleteConfirm', $event)"
    />
  </div>

  <div class="flx-modal-footer">
    <div class="flx-modal-footer__right">
      <button
        (click)="closeModal()"
        class="flx-ds secondary"
        data-testId="confirmation-modal-cancel-button"
        flxButton
        type="button"
      >
        Cancel
      </button>
      <button
        (click)="confirm()"
        class="flx-ds primary danger"
        data-testId="confirmation-modal-confirm-button"
        flxButton
        type="button"
      >
        {{ data.action === 'update' ? 'Update' : 'Delete' }}
      </button>
    </div>
  </div>
</flx-modal>
